import Image from 'next/image';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { trackFootfallEventWithHrefDelay } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import config from 'config/config';
import { titleMedium } from 'styles-js/mixins/typography';
export default function RedirectPage() {
  const router = useRouter();
  const url = (router.query.url as string)?.replace(/javascript:/ig, '') ?? '';
  return <Container data-sentry-element="Container" data-sentry-component="RedirectPage" data-sentry-source-file="redirect.tsx">
      <StyledImage alt="HealthUnlocked" height={177} sizes="220px" src={`${config.cdn.static}img/healthunlocked-logo-green.png`} width={827} data-sentry-element="StyledImage" data-sentry-source-file="redirect.tsx" />
      <h1>Redirect Notice</h1>
      <p>
        Looks like you clicked
        <a href={url} rel="nofollow ugc noreferrer" onClick={e => {
        e.preventDefault();
        trackFootfallEventWithHrefDelay(url, Event.Clicked, {
          clickType: 'redirect',
          clickMetadata: {
            url
          }
        });
      }}>
          {url}
        </a>
      </p>
      <p>If you do not want to visit that page, you can close this browser tab.</p>
    </Container>;
}
const Container = styled.div`
  margin: 30px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  text-align: center;
  border: ${({
  theme
}) => theme.greyLine};
  max-width: 700px;
  h1 {
    ${titleMedium}
    margin-top: 35px;
  }
  a {
    word-wrap: break-word;
    display: block;
    margin: 10px 0;
  }
`;
const StyledImage = styled(Image)`
  width: 220px;
  height: auto;
`;